







import Vue from 'vue'

export default Vue.extend({
  name: 'LineEl',

  computed: {
    getBackgroundColor (): string {
      return `background-color: ${this.$props.templateItemData.separator || 'white'}`
    }
  },

  props: {
    templateItemData: {
      type: Object,
      required: true
    }
  }
})
